import React, { useEffect, useState } from 'react'

import _, { isEmpty } from 'lodash'
import { Container } from 'react-bootstrap'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { QuizQuestionAPI } from '../../Api/QuizQuestions'
import { Button, Description, DescriptionLight, Headline } from '../../Components/CustomComponent'
import TimerNavbar from '../../Components/Layouts/TimerNavbar'
import { useAppContext } from '../../Context/AppContext'
import { useSocket } from '../../Context/SocketContext'
import { Toast } from '../../Hooks/useToast'
import { OPTIONS_TYPES, QUESTION_TYPES, STRING } from '../../constants'
import AudienceSupport from './components/AudienceSupport'
import styles from "./styles/Audience.module.scss"
import { flushSync } from 'react-dom'

export default function Audience({ data }) {
    const navigate = useNavigate()
    const { isSocketConnected, user } = useAppContext()
    const socket = useSocket()
    const quizQuestionAPI = QuizQuestionAPI()
    const [isReplied, setIsReplied] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(undefined)
    const [currentQuestion, setCurrentQuestion] = useState(findQuestionById(data.active_question_id))
    const [answer, setAnswer] = useState(null);
    const [buzzerUser, setBuzzerUser] = useState(!isEmpty(data.buzzer_user) ? data.buzzer_user : null);

    const quizQuestionMutation = useMutation(quizQuestionAPI.answerQuizQuestion, {
        onSuccess: (data) => {
            setIsReplied(true)

        },
        onError: (err) => {
            Toast(err.message || STRING.server_error, 'error', false)
            setIsSubmitted(undefined)
        }
    })



    useEffect(() => {
        let audio;
        try {
            audio = new Audio("/assets/sounds/quiz_game_sound.mp3"); // Path to your sound file
            audio.loop = true;
            audio?.play();
        }
        catch (err) { }

        return () => {
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        }
    }, [])

    useEffect(() => {
        if (isSocketConnected) {
            socket.on('_moveNext', (data) => {
                const nextQuestion = findQuestionById(data?.nextQuestion?.id)
                flushSync(() => {
                    setCurrentQuestion(prev => ({ ...nextQuestion }));
                    setAnswer(null)
                    setBuzzerUser(null)
                    setIsReplied(false)
                    setIsSubmitted(undefined)
                })

            })

            if (data.user_id === user.id) {
                socket.on('_participantTyping', (data) => {
                    setAnswer(data?.typing);
                })
                socket.on('_participantSelectedOption', (data) => {
                    const option = currentQuestion.question_options.find(item => item.id === data.option_id)
                    setAnswer(option)
                })
                socket.on('_buzzerPressed', (data) => {
                    setBuzzerUser(data.buzzer_user)
                })
                socket.on('_buzzerReleased', (data) => {
                    setBuzzerUser(null)
                    setAnswer(null);
                })
            }

        }
        return () => {
            socket.dispose('_moveNext')
            socket.dispose('_participantTyping')
            socket.dispose('_participantSelectedOption')
            socket.dispose('_buzzerPressed')
            socket.dispose('_buzzerReleased')
        }
    }, [isSocketConnected, currentQuestion])




    const handleAnswerClick = (answer_id) => {
        if (!_.isUndefined(isSubmitted) || isReplied) return;
        setIsSubmitted(answer_id)

        const payload = {};
        payload.quiz_id = data.id;
        // payload.audience_poll_id = data.audience_id;
        payload.question_id = currentQuestion.id;
        payload.answer = answer_id;
        quizQuestionMutation.mutate(payload)
    }


    function findQuestionById(question_id) {
        if (!question_id && !!data?.quiz_questions.length) return data?.quiz_questions[0]
        return data?.quiz_questions?.find(item => item.id === question_id) || {}
    }

    const handleClose = () => {
        navigate(-1, { replace: true })
    }

    return (
        <Container className={styles.Audience}>
            <img src="/assets/quiz-cover.jpg" alt="Quiz Cover" className={styles.quizCover} />

            <div className={styles.topBar}>
                <TimerNavbar isTimer={false} isCoins={false} onClose={handleClose} />
            </div>
            <div className={styles.coverImage}>
                <img
                    key={currentQuestion.id}
                    src={currentQuestion?.image_url || data.cover_image_url}
                    alt="Cover Image"
                    className={styles.image}
                />
            </div>
            <div className={styles.content}>
                <DescriptionLight
                    text={`Question ${currentQuestion?.position || 0} of ${data.quiz_questions?.length}`}
                    size='55'
                />
                <Headline
                    text={currentQuestion?.question}
                    classes='mt-2 mb-4'
                />
                <div className={styles.answersContainer}>
                    {currentQuestion?.question_type === QUESTION_TYPES.BLANK ?
                        <DescriptionLight
                            text={`Unable to respond to the text-based question.`}
                            size='text-center my-5 mx-auto fs-5'
                        />
                        : !isReplied ?
                            currentQuestion?.question_options?.map((item, ind) => {
                                return <Button
                                    text={item?.option_type === OPTIONS_TYPES.TEXT ?
                                        item.option :
                                        <img src={item.image_url} alt={'Option Image ' + ind} />}
                                    lightTheme={true}
                                    classes='fw-bold'
                                    onClick={() => handleAnswerClick(item.id)}
                                    isSubmitted={isSubmitted === item.id}
                                />
                            }) :
                            <AudienceSupport quiz_id={data.id} question_id={currentQuestion?.id} options={currentQuestion?.question_options} />
                    }
                </div>

                {!buzzerUser ? <></> :
                    <div className='mt-5 mb-3'>
                        <div className='text-center mb-3'>
                            {currentQuestion.question_type === QUESTION_TYPES.BLANK ?
                                <Description text={'Answer : ' + (answer || '')} classes='text-center' /> :
                                isEmpty(answer) ? <></> :
                                    answer.option_type === OPTIONS_TYPES.IMAGE ?
                                        <img src={answer?.image_url} alt={'Option Image'} style={{ maxWidth: "100px" }} /> :
                                        answer.option_type === OPTIONS_TYPES.TEXT ?
                                            <Description text={answer?.option} classes='text-center' /> :
                                            <></>
                            }
                        </div>

                        <div className={`${styles.buzzerUser} mt-0`} key={buzzerUser?.id || ''}>
                            <img
                                src={buzzerUser.image_url}
                                alt='Buzzer User Image'
                                className={styles.image}
                            />
                            <Description
                                text={buzzerUser.name}
                                classes='my-2'
                            />
                        </div>
                    </div>

                }
            </div>

        </Container >
    )
}
